import mitt from 'mitt'

type Event = {
    changeInputValue: string
}

export const fieldInputEmitter = mitt<Event>()
